// removed by extract-text-webpack-plugin
module.exports = {"Card":"_2N7jfdbiFoZAkrUP_FpPUc","PaginationWrap":"_21UQfKXo0C2KNQ1VvZ_sG8","ActiveLink":"_2Teik0jCGk9UEQ3r9m5Mt-","FiltersToggle":"BHlX47RAhyi9QKlMhzQvc","MainColumn":"_2Dm-5Exgy4IwfyqO8PTiJL","SidebarColumn":"_17lS4bjYCWPSqSo3k6jKHI"};


//////////////////
// WEBPACK FOOTER
// ./src/PagesOfUser/MobilePayouts/styles.module.css
// module id = 636
// module chunks = 0